import React, { useContext } from 'react'

import { ThemeContext } from './ThemeContext'

const LoadingIcon: React.FC = () => {
    const { theme } = useContext(ThemeContext)

    return (
        <svg
            className="animate-spin h-10 w-10 text-[#FFFFFF]"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
        >
            <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke={theme == 'dark' ? '#FFFFFF' : '#181818'}
                strokeWidth="4"
            ></circle>
            <path
                className="opacity-75"
                fill={theme == 'dark' ? '#FFFFFF' : '#181818'}
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
            ></path>
        </svg>
    )
}

export default LoadingIcon
